import React from 'react';
import './FactionHumansDescription.css';
import {CoinsStat} from "../../../PlayerStat/stats/CoinsStat";
import {FACTION_HUMANS_POLICY_DISCOUNT} from "../../../../configs/factions/humans";

const FactionHumansDescription = () => {
  const discount = <CoinsStat
    text={FACTION_HUMANS_POLICY_DISCOUNT}
    noShrinkOnMobile={true}
    isDarkColor={true}
    className={'policy-description-icon-margin-left-end'}
  />;

  const discountElement = <img
    className={'policy-description-icon policy-description-icon-margin-right-left'}
    src={'/img/icons/percent white.png'}
    alt={'Скидка'}
    title={'Скидка'}
  />;

  return (
    <>
      <div className="policy-description_line">
        Цена политик дешевле {discountElement} на {discount}.
      </div>
      <div className="policy-description_line policy-description_line-margin-top-paragraph">
        Политики активируются мгновенно.
      </div>
    </>
  );
};

export default FactionHumansDescription;
